/**
 * @author Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2019-09-26
 * @description Implementation of  companies and organizations inner page.
 * @filename profile-claim.tsx
 */

import React from "react";
import { commitMutation } from "../../../utilities/relay";
import { getClientMutationId } from "../../../utilities/general";
import { ENVIRONMENT } from "../../../relay/relay-environment";
import { CLAIM_PROFILE_GRAPHQL_MUTATION } from "../../../relay/mutations/claim-profile";
import { RdvButton } from "../../page-framework/rdv-button";

export default function review(props: {
  invitationId: string;
  expiryDate: string;
  actions: { success: Function; loading: Function };
}) {
  const claimRequestData = [
    { name: "Invitation id", detail: props.invitationId },
    { name: "Invitation Type", detail: "Sign Up Invitation" },
    { name: "Expiry date", detail: new Date(props.expiryDate).toUTCString() },
  ];
  return (
    <div className="invitation-section">
      <div className="form-group row">
        <div className="col-sm-12 col-xs-12">
          <h3>Invitation details</h3>
        </div>
      </div>
      {claimRequestData.map((payment) => (
        <div className="form-group row" key={payment.name}>
          <div className="col-sm-6 col-xs-6">
            <h6>{payment.name}</h6>
          </div>
          <div className="col-sm-6 col-xs-6">
            <h6>{payment.detail}</h6>
          </div>
        </div>
      ))}
      <RdvButton
        type="submit"
        extraClassName="btn-root"
        text="Claim Profile"
        onClick={() => {
          props.actions.loading();
          return commitMutation(ENVIRONMENT, {
            mutation: CLAIM_PROFILE_GRAPHQL_MUTATION,
            variables: {
              input: {
                clientMutationId: getClientMutationId(),
                invitationId: props.invitationId,
              },
            },
          })
            .then((res) => {
              props.actions.success(
                res.claimProfileOwnerShip.person ? res.claimProfileOwnerShip.person : res.claimProfileOwnerShip.entity,
              );
            })
            .catch((err) => {
              props.actions.success(undefined);
            });
        }}
      />
    </div>
  );
}
